import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal,Badge, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { Link } from "react-router-dom";
import $ from "jquery";
import Select, {components} from "react-select";



const Dispatch_Product_Corp = ({ show, onClose }) => {

    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };

    const [selectedOption, setSelectedOption] = useState(null);
    const handleSelect = (e) => {
        setSelectedOption(e.target.selected);
    };
    // const handleCheckboxChange = () => {
    //     checkIsChecked(!Checked);
    // };
    const [isChecked, setIsCheckedpass] = useState(false);
    

    const options_vehicles = [
        { value: "1", label: "Auto" },
        { value: "2", label: "Mini Lorry" },
        { value: "3", label: "Bajaj" },
        { value: "4", label: "Bike" },
    ];

    const option_staff = [
        { value: "1", label: "Chithra" },
        { value: "2", label: "Marimuthu" },
        { value: "3", label: "Thilak" },
        { value: "4", label: "Raju" },
    ];

    const tableRef = useRef(null);
    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    //   "aaSorting": [],
                    "ordering": false,
                    "paging": false,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        // "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        // "<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        // "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);

    const Group = (props) => (
        <div style={customStyles}>
            <components.Group {...props} />
        </div>
    );
    const customStyles = {
        groupHeading: (provided) => ({
            ...provided,
            fontSize: '14px',  // Increase the font size for group labels
            fontWeight: 'bold',  // Optional: make the label bold
            color: '#333',  // Optional: change the text color
            backgroundColor: "#fff"
        }),
    };

    
    
    const [rawMatrial, setRawMatrial] = useState([{ 
        id: Date.now(), 
        selectedVehicle: null, 
        isChecked: false,
        selectedStaff: null,
    }]);

    const handleVehicleChange = (id, selected) => {
        setRawMatrial(prev =>
            prev.map(config =>
                config.id === id ? { ...config, selectedVehicle: selected } : config
            )
        );
    };

    const handleCheckboxChange = (id, checked) => {
        setRawMatrial(prev =>
            prev.map(config =>
                config.id === id ? { ...config, isChecked: checked } : config
            )
        );
    };

    const handleStaffChange = (id, selected) => {
        setRawMatrial(prev =>
            prev.map(config =>
                config.id === id ? { ...config, selectedStaff: selected } : config
            )
        );
    };

    // Add new IP configuration
    const handleAddConfig = () => {
        setRawMatrial([...rawMatrial, { id: Date.now() }]);
    };

    // Delete an IP configuration
    const handleDeleteConfig = (id) => {
        setRawMatrial(rawMatrial.filter(config => config.id !== id));
    };
    return (
        <Modal show={show} onHide={onClose} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Product Dispatch</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className='row mb-4'>
                        <div className="col-lg-4 d-flex flex-column align-items-start justify-content-start  mb-2">
                            <label className='text-danger font-w600 fs-5'>Keshvi Shri</label>
                            <label className="fs-7 text-dark">9874514006</label>
                        </div>
                        <div className="col-lg-4 d-flex flex-column align-items-start justify-content-start  mb-2">
                            <label className='text-danger font-w600 fs-5'>Shri Solutions Ltd</label>
                            <label className="fs-7 text-dark">6325410258</label>
                        </div>
                        <div className="col-lg-4 d-flex flex-column align-items-start justify-content-start  mb-2">
                            <label className='text-danger font-w600 fs-5'>CORPOR-015/2025</label>
                            <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Order Delivery Date                                </span></Tooltip>} >
                                <label className="fs-7 text-dark">20-Aug-2025</label>
                            </OverlayTrigger>
                        </div>
                        <hr></hr>
                        <div className='col-lg-3 mb-2'>
                            <div className='d-flex flex-column align-items-start justify-content-start'>
                                <label className='text-black font-w500 fs-5'>Packed Items</label>
                                <label className="fs-5 text-danger font-w500 border border-danger py-1 px-2 rounded">02</label>
                            </div>
                        </div>
                        <div className='col-lg-3 mb-2'>
                            <div className='d-flex flex-column align-items-start justify-content-start'>
                                <label className='text-black font-w500 fs-5'>Total Items</label>
                                <label className="fs-5 text-danger font-w500 border border-danger py-1 px-2 rounded">04</label>
                            </div>
                        </div>
                        <div className='col-lg-3 mb-2'>
                            <div className='d-flex flex-column align-items-start justify-content-start'>
                                <label className='text-black font-w500 fs-5'>Total Cookwares</label>
                                <label className="fs-5 text-danger font-w500 border border-danger py-1 px-2 rounded">134</label>
                            </div>
                        </div>
                        <div className='col-lg-3 mb-2'>
                            <div className='d-flex flex-column align-items-start justify-content-start'>
                                <label className='text-black font-w500 fs-5'>Total Add-On's</label>
                                <label className="fs-5 text-danger font-w500 border border-danger py-1 px-2 rounded">05</label>
                            </div>
                        </div>
                        <div className='col-lg-7 mb-2'>
                            <div className='d-flex flex-column align-items-start justify-content-start'>
                                <label className='text-black font-w500 fs-5'>Delivery Address</label>
                                <label className="fs-5 text-black font-w300">12/A, Bharat Cross Street, Anna Nagar, Madurai -625014</label>
                            </div>
                        </div>
                    </div>
                    <div className='row mb-2'>
                       <div className='scroll-y mh-350px py-2'>
                            <div className="col-lg-12">
                                <div className="mb-0">
                                    {rawMatrial.map(config => (
                                        <div key={config.id} data-repeater-item>
                                            <div className="row">
                                                <div className="col-lg-3 mb-4">
                                                    <label className="text-black font-w500 fs-6">
                                                        Assign Vehicle<span className="required">*</span>
                                                    </label>
                                                    <Select 
                                                        placeholder="Select Vehicle"
                                                        onChange={(selected) => handleVehicleChange(config.id, selected)}
                                                        options={options_vehicles}
                                                        value={config.selectedVehicle}
                                                    />
                                                </div>

                                                <div className="col-lg-3 mb-2">
                                                    <label className="text-black font-w500 fs-6">
                                                        <input
                                                            type="checkbox"
                                                            onChange={(e) => handleCheckboxChange(config.id, e.target.checked)}
                                                            className="form-check-input me-2"
                                                            id={`customCheckBox-${config.id}`}
                                                        />
                                                        Swift Staff
                                                        {config.isChecked && (<span className="required">*</span>)}
                                                    </label>
                                                    {config.isChecked && (
                                                        <Select
                                                            placeholder="Select Staff"
                                                            onChange={(selected) => handleStaffChange(config.id, selected)}
                                                            options={option_staff}
                                                            value={config.selectedStaff}
                                                        />
                                                    )}
                                                </div>

                                                {config.selectedVehicle && (
                                                    <div className="col-lg-4 mb-2">
                                                        <label className="text-black font-w500 fs-6">Vehicle</label>
                                                        <div className="d-flex flex-row align-items-start justify-content-start gap-2 mb-2">
                                                            <label className="text-danger font-w600 fs-6">{config.selectedVehicle.label}</label>
                                                            <label className="text-dark font-w600 fs-6">(TN64C2541)</label>
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="col-lg-1 mb-1 px-1 py-1">
                                                    {rawMatrial.length > 1 && (
                                                        <button
                                                            className="btn btn-danger mt-4 px-2 py-2"
                                                            onClick={() => handleDeleteConfig(config.id)}
                                                            data-bs-toggle="tooltip"
                                                            data-bs-placement="top"
                                                            title="Delete"
                                                        >
                                                            <i className="fa-solid fa-trash-can fs-6 mt-1 text-white"></i>
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mb-1 mt-1">
                        <button
                            className="btn btn-sm btn-primary"
                            onClick={handleAddConfig}
                        >
                            <span><i className="fa-solid fa-plus fs-6"></i></span>
                            <span className='ms-2 fs-7'>Add More</span>
                        </button>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Dispatch Product
                            <i className="fas fa-angle-double-right ms-2"></i>
                        </Link>
                    </div>
                </div>
            </div>
        </Modal >
    );
}

export default Dispatch_Product_Corp;